module.exports = __webpack_public_path__ + "static/img/fund2.a70ed23.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/fundClassify/fund2.png
// module id = GxOq
// module chunks = 0